import AirportInput from "./AirportInput";
import { changeViaAirport } from "../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { faPlane } from "@fortawesome/free-solid-svg-icons/faPlane";
import { useTranslation } from "react-i18next";

function ViaAirportInput() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const viaAirport = useAppSelector(
    (state) => state.searchFlights.form.viaAirport
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const validity = useAppSelector(
    (state) => state.searchFlights.formValidity.viaAirport
  );

  const onSelect = (suggestion) => {
    dispatch(changeViaAirport(suggestion));
  };

  if (!viaAirport) {
    return null;
  }

  return (
    <AirportInput
      id="via-airport-input"
      airport={viaAirport}
      validity={validity}
      validityMessage=""
      icon={faPlane}
      label={t("INPUT_LABEL_VIA")}
      title=""
      onSelect={onSelect}
      disabled={viaAirport?.readOnly || disabled}
    />
  );
}

export default ViaAirportInput;
